import { render, staticRenderFns } from "./Create-Invoice.vue?vue&type=template&id=ff62a932&scoped=true"
import script from "./Create-Invoice.vue?vue&type=script&lang=js"
export * from "./Create-Invoice.vue?vue&type=script&lang=js"
import style0 from "./Create-Invoice.vue?vue&type=style&index=0&id=ff62a932&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff62a932",
  null
  
)

export default component.exports